import { gql } from '@apollo/client';

export const PERSON_FIELDS = gql`
  fragment Person on Person {
    id
    createdAt
    updatedAt
    isTest
    status
    currentOrgId
    systemAccount
  }
`;

export const PERSON_ORG_FIELDS = gql`
  fragment PersonOrg on PersonOrg {
    id
    email
    role
    orgId
    personId
  }
`;

export const PERSON_ORG_VERIFICATION_FIELDS = gql`
  fragment PersonOrgVerification on PersonOrgVerification {
    id
    createdAt
    updatedAt
    methodId
    personOrgId
    title
    firstName
    middleName
    lastName
    dateOfBirth
    gender
    status
  }
`;
// idTypeId // moved to personOrgVerificationIdTypes
// idNumber
// idExpiry

export const ORG_FIELDS_CORE = gql`
  fragment OrgFieldsCore on Org {
    id
    name
    type
  }
`;

export const LoginMutationStatement = gql`
  mutation login($data: LoginInput!) {
    login(data: $data) {
      accessToken
    }
  }
`;

export const RefreshTokenMutationStatement = gql`
  mutation refreshToken {
    refreshToken {
      accessToken
    }
  }
`;

export const MeQueryStatement = gql`
  ${PERSON_FIELDS}
  ${PERSON_ORG_FIELDS}
  ${PERSON_ORG_VERIFICATION_FIELDS}
  ${ORG_FIELDS_CORE}
  query me {
    me {
      ...Person
      personOrgs {
        ...PersonOrg
        org {
          ...OrgFieldsCore
        }
        verificationsOf {
          ...PersonOrgVerification
        }
      }
    }
  }
`;

export const LogOutMutationStatement = gql`
  mutation logOut {
    logOut
  }
`;

export const RegisterUserForAuthStatement = gql`
  ${PERSON_FIELDS}
  ${PERSON_ORG_FIELDS}
  ${PERSON_ORG_VERIFICATION_FIELDS}
  ${ORG_FIELDS_CORE}
  mutation registerUserForAuth {
    registerUserForAuth {
      ...Person
      personOrgs {
        ...PersonOrg
        org {
          ...OrgFieldsCore
        }
        verificationsOf {
          ...PersonOrgVerification
        }
      }
    }
  }
`;
